var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36875 12.5063C4.48125 11.4625 3.9125 9.91875 3.875 8.1875V7.8125C3.9125 6.08125 4.4875 4.5375 5.36875 3.49375C6.51875 2.00625 8.20625 1.3375 10.1125 1.3375C11.2875 1.3375 12.3938 1.41875 13.3313 2.04375C11.925 0.775 10.0687 0.00625 8.03125 0H8C3.58125 0 0 3.58125 0 8C0 12.2875 3.375 15.7937 7.61875 15.9937C7.74375 16 7.875 16 8 16C10.05 16 11.9188 15.2312 13.3313 13.9625C12.3938 14.5875 11.35 14.6125 10.175 14.6125C8.275 14.6188 6.5125 14 5.36875 12.5063V12.5063Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36877 3.49365C6.10002 2.6249 7.05002 2.10615 8.08752 2.10615C10.4188 2.10615 12.3063 4.74365 12.3063 8.00615C12.3063 11.2687 10.4188 13.9062 8.08752 13.9062C7.05002 13.9062 6.10627 13.3812 5.36877 12.5187C6.51877 14.0062 8.22502 14.9562 10.125 14.9562C11.2938 14.9562 12.3938 14.5999 13.3313 13.9749C14.9688 12.4999 16 10.3687 16 7.9999C16 5.63115 14.9688 3.4999 13.3313 2.0374C12.3938 1.4124 11.3 1.05615 10.125 1.05615C8.21877 1.05615 6.51252 1.9999 5.36877 3.49365V3.49365Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 6.66603,
    y1: 0.2608,
    x2: 6.66603,
    y2: 15.7672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4381,
    stopColor: "#FA1A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5939,
    stopColor: "#ED1528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#D60E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9272,
    stopColor: "#B70519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 10.6833,
    y1: 1.17472,
    x2: 10.6833,
    y2: 14.8893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF4B4B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpera);
export default __webpack_public_path__ + "static/media/opera.b95037095670884dea2d90764c13cc77.svg";
export { ForwardRef as ReactComponent };